import { useRef, useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";

const bottomBadges = [
  "Compatible tous appareils",
  "Sans inscription",
  "Vraie carte, essayez-la",
];

export const InteractiveDemo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  // Mount detection
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // IntersectionObserver après mount (même pattern que VideoSection)
  useEffect(() => {
    if (!isMounted || !contentRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, [isMounted]);

  return (
    <section
      id="interactive-demo"
      className="pt-0 pb-6 sm:pb-8 lg:pb-8 -mt-1.5 sm:-mt-3.5 lg:-mt-4 px-4 sm:px-6 lg:px-8 scroll-mt-20"
    >
      <div
        ref={contentRef}
        className={`max-w-5xl mx-auto transition-all duration-700 ease-out ${
          isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-5"
        }`}
      >
        {/* Stack vertical centré (même layout desktop et mobile) */}
        <div className="text-center mb-8">
          {/* Badge top */}
          <div className="flex justify-center mb-6">
            <span className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#074155] bg-white text-sm font-semibold text-[#074155]">
              Démo interactive
            </span>
          </div>

          {/* Titre H2 */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#074155] mb-4">
            Découvrez les notifications écran verrouillé{" "}
            <span className="text-[#0C94A6]">sans app</span>
          </h2>

          {/* Paragraphe */}
          <p className="text-[14px] sm:text-base font-medium leading-relaxed text-[#495456] max-w-3xl mx-auto">
            Ceci est une vraie carte <span className="text-[#0C94A6] font-semibold">Unotif</span>. Testez l'expérience complète : ajout au Wallet, notifications, mise à jour. Tout comme vos futurs abonnés.
          </p>
        </div>

        {/* Iframe Card */}
        <div
          className="overflow-hidden rounded-[20px] sm:rounded-[24px] bg-white max-w-2xl mx-auto mt-4 mb-10"
          style={{
            boxShadow:
              "0 8px 32px -8px rgba(0, 0, 0, 0.12), 0 4px 16px -4px rgba(0, 0, 0, 0.08)",
          }}
        >
          <iframe
            src="https://app.unotif.com/p/PS257049276616?embed=true&theme=light"
            style={{ width: "100%", height: "600px", border: "none", borderRadius: "12px" }}
            loading="lazy"
          ></iframe>
        </div>

        {/* Badges bottom */}
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {bottomBadges.map((badge, index) => (
            <span
              key={index}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#0c97a9] bg-[#0C94A6]/15 text-sm font-semibold text-[#0c97a9]"
            >
              <CheckCircle className="w-4 h-4" />
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
